import React, { useEffect } from "react"
import { useLocation } from "react-router-dom";
import HttpServices from "../../services/HttpServices";

export const GoogleCallback = () => {
    const location = useLocation();

    console.log('location', location);

    useEffect(() => {
        googleAuthSignIn()
    }, []);

    const googleAuthSignIn = async () => {

        fetch(`http://localhost:81/sojourn-core/public/api/v1/identity/auth/google/callback${location.search}`, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then((response) => {
                console.log('response', response);
                return response.json();
            })
            .then((data) => {
                // setLoading(false);
                // setData(data);
                console.log('data', data);
                
            });
    }

    return (
        <React.Fragment>
            <h1>
                Google Callback
            </h1>


        </React.Fragment>
    )
}